import { render, staticRenderFns } from "./OrderFormModular.vue?vue&type=template&id=27a8f928&scoped=true&"
import script from "./OrderFormModular.vue?vue&type=script&lang=js&"
export * from "./OrderFormModular.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormModular.vue?vue&type=style&index=0&id=27a8f928&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a8f928",
  null
  
)

export default component.exports